import { Dialog } from "primereact/dialog";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { Dropdown } from "primereact/dropdown";
import { useProjectAddOrEdit } from "../../Hooks/Features/ProjectHighlight/useProjectAddOrEdit";
import "./addProjectStyle.css";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Calendar } from "primereact/calendar";
import {
  createAbbreviation,
  dateConvert,
  MuiCss,
  MuiTextInputStyle,
} from "../../utils/Helper";
import { useCommon } from "../../Hooks/Common/useCommon";

const filter = createFilterOptions();

const AddOrEditProject = ({ addProjectPopup, setAddProjectPopup, selectProjectId, selectProjectData, setSelectProjectId, getProjectHighlights,
}) => {
  const { option, rows, addRow, handleDropdownChange, handleMultiSelectChange, projectData, setProjectData, addProjectUserRole, handleChange, userHandleChange, addOrEditProject, deleteUser, deleteIssueType, editProject, setEditProject, getProjectDetails, handleEvent, tagRef, checkPermission, addIssueType, handleRadioChange, confirmation, setConfirmation, showPopup, setShowPopup, handleSelection, mismatchedUsers, showInfo, } = useProjectAddOrEdit({ selectProjectId, selectProjectData, setAddProjectPopup, getProjectHighlights });
  const { getValuePermission } = useCommon();

  return (
    <>
      <Dialog
        className="timesheet-dialog"
        modal={true}
        draggable={false}
        style={{ width: "98vw", maxHeight: "100%", minHeight: "98vh" }}
        visible={addProjectPopup}
        onHide={() => {
          setAddProjectPopup(false);
          setProjectData({});
          setSelectProjectId(null);
        }}
        header={() => {
          return (
            <div style={{ color: "black" }}>
              {selectProjectId ? "Edit Project" : "Create New Project"}
            </div>
          );
        }}
      >
        <div>
          <div className="d-flex align-items-end gap-2">
            {/* <div className="mb-2">
              <img src="./assets/srkay-icon.png" alt="" width={30} height={30} />
            </div> */}
            <div className="w15">
              <label>Product Code</label>
              <Dropdown
                placeholder="Product"
                options={option?.productOption}
                optionLabel="product_name"
                className="input-dd"
                name="product_code"
                value={projectData?.product_code}
                onChange={handleChange}
                disabled={true}
              />
            </div>
            <div className="w15">
              <label>Project Name</label>
              <div className="d-flex gap-2">
                {editProject ? (
                  <input
                    name="project_name"
                    value={projectData?.project_name?.project_name}
                    onChange={(e) => {
                      setProjectData((prev) => ({
                        ...prev,
                        project_name: { project_name: e.target.value },
                        project_key: createAbbreviation(e.target.value),
                      }));
                    }}
                    className="input-dd"
                    style={{ width: "100%" }}
                    disabled={
                      !projectData?.product_code?.is_default ||
                      getValuePermission(
                        "add_project_info_save_btn"
                      )
                    }
                    placeholder="Enter Project name"
                  />
                ) : (
                  <Autocomplete
                    className="common-autocomplete"
                    value={projectData?.project_name}
                    name=""
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setProjectData((prev) => ({
                          ...prev,
                          project_name: { project_name: newValue },
                          project_key: createAbbreviation(newValue),
                          project_id: 0,
                        }));
                      } else if (newValue && newValue?.inputValue) {
                        setProjectData((prev) => ({
                          ...prev,
                          project_name: {
                            project_name: newValue.inputValue,
                          },
                          project_key: createAbbreviation(
                            newValue.inputValue
                          ),
                          project_id: 0,
                        }));
                      } else {
                        newValue?.project_id &&
                          getProjectDetails(newValue?.project_id, newValue?.product_code);
                        setProjectData((prev) => ({
                          ...prev,
                          project_name: newValue,
                          project_key: newValue?.project_key,
                          project_id: newValue?.project_id,
                        }));
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);
                      const { inputValue } = params;
                      if (
                        inputValue !== "" &&
                        !options.some(
                          (option) => inputValue === option.project_name
                        )
                      ) {
                        filtered.push({
                          inputValue,
                          project_name: `${inputValue}`,
                        });
                      }
                      return filtered;
                    }}
                    options={option?.projectsOption}
                    getOptionLabel={(option) =>
                      typeof option === "string"
                        ? option
                        : option.project_name || ""
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.project_id}>
                        {option.project_name}
                      </li>
                    )}
                    sx={MuiCss}
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label={selectProjectId ? "Edit Project" : "Add Project"}
                        style={{ width: "100%" }}
                        sx={MuiTextInputStyle}
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (
                            typeof value === "string" &&
                            value !==
                            projectData?.project_name?.project_name
                          ) {
                            setProjectData((prev) => ({
                              ...prev,
                              project_name: { project_name: value },
                              project_key: createAbbreviation(value),
                              project_id: 0,
                            }));
                          }
                        }}
                      />
                    )}
                    placeholder="Select Project"
                    defaultValue={projectData?.project_name}
                    disabled={
                      !projectData?.product_code?.is_default ||
                      getValuePermission(
                        "add_project_info_save_btn"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                )}
                <div className="align-self-center">
                  {projectData?.project_id !== 0 &&
                    projectData?.project_id !== undefined &&
                    projectData?.product_code?.is_default &&
                    !editProject ? (
                    <FontAwesomeIcon
                      icon="fa-solid fa-edit"
                      onClick={() => setEditProject(!editProject)}
                    />
                  ) : (
                    <>
                      {projectData?.project_id !== 0 &&
                        projectData?.project_id !== undefined &&
                        projectData?.product_code?.is_default && (
                          <FontAwesomeIcon
                            icon="fa-solid fa-close"
                            onClick={() => setEditProject(!editProject)}
                          />
                        )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="w10">
              <label>Project Key</label>
              <input
                name="project_key"
                value={
                  projectData?.project_key
                    ? projectData?.project_key
                    : createAbbreviation(
                      projectData?.project_name?.project_name
                    )
                }
                onChange={handleChange}
                className="input-dd"
                style={{ width: "100%" }}
                disabled={
                  !projectData?.product_code?.is_default ||
                  getValuePermission(
                    "add_project_info_save_btn"
                  )
                }
                placeholder="Enter Project key"
              />
            </div>
            <div className="w10">
              <label>Client Name</label>
              <MultiSelect
                onChange={(e) => {
                  setProjectData((prev) => ({
                    ...prev,
                    client_id: e.target.value,
                  }));
                }}
                options={option?.clientOption || []}
                filter
                filterInputAutoFocus
                placeholder="Client"
                value={projectData?.client_id}
                optionLabel="client_name"
                className="input-dd"
                panelHeaderTemplate={(options) =>
                  PanelHeaderTemplate(
                    options,
                    "client_id",
                    projectData?.client_id,
                    () => { },
                    () =>
                      setProjectData((prevState) => ({
                        ...prevState,
                        client_id: [],
                      }))
                  )
                }
              />
            </div>
            <div className="w10">
              <label>Type</label>
              <Dropdown
                placeholder="Type"
                options={option?.projectTypeOption}
                optionLabel="project_type_name"
                className="input-dd"
                name="project_type_id"
                value={projectData?.project_type_id}
                onChange={handleChange}
                disabled={
                  !projectData?.product_code?.is_default ||
                  getValuePermission(
                    "add_project_info_save_btn"
                  )
                }
              />
            </div>
            <div className="w10">
              <label>Status</label>
              <Dropdown
                placeholder="Status"
                options={option?.projectStatus}
                optionLabel="project_status_name"
                className="input-dd"
                name="project_status_id"
                value={projectData?.project_status_id}
                onChange={handleChange}
                disabled={
                  getValuePermission(
                    "add_project_info_save_btn"
                  )
                }
              />
            </div>
            <div className="w10 inspectra-calendar">
              <label>Start Date</label>
              <Calendar
                className="input-dd"
                dateFormat="dd-mm-yy"
                style={{ height: "100%" }}
                placeholder="Log Date"
                name="project_start_date"
                value={projectData?.project_start_date}
                onChange={handleChange}
                disabled={
                  getValuePermission(
                    "add_project_info_save_btn"
                  )
                }
              />
            </div>
            <div className="w10 inspectra-calendar">
              <label>End Date</label>
              <Calendar
                className="input-dd"
                dateFormat="dd-mm-yy"
                style={{ height: "100%" }}
                placeholder="Log Date"
                name="project_end_date"
                value={projectData?.project_end_date}
                onChange={handleChange}
                disabled={
                  getValuePermission(
                    "add_project_info_save_btn"
                  )
                }
              />
            </div>
            {
              !getValuePermission("project_auto_build") && <div className="w5">
                <label htmlFor="is_auto_build_allow" title="Allow Auto Build" className="ms-1  text-truncate my-1"> Auto Build</label><br />
                <input
                  type="checkbox"
                  id="checkbox"
                  name="is_auto_build_allow"
                  className="m-0"
                  checked={projectData?.is_auto_build_allow}
                  onChange={handleChange}
                />
              </div>
            }

            {
              !getValuePermission("allow_project_import") && <div className="w5">
                <label htmlFor="is_import_allow" title="Allow Project Import" className="ms-1 text-truncate my-1"> Import Allow</label><br />
                <input
                  type="checkbox"
                  id="checkbox"
                  name="is_import_allow"
                  className="m-0"
                  checked={projectData?.is_import_allow}
                  onChange={handleChange}
                />
              </div>
            }

            <div
              className=" mt-2"
              ref={() => checkPermission("Project Highlight", tagRef)}
            >
              <button
                ref={tagRef}
                id='{"tabname": "Project Highlight", "data": "add_project_info_save_btn"}'
                className="btn btn-primary"
                onClick={addOrEditProject}
              >
                Save
              </button>
            </div>
          </div>

        </div>
        <div className="d-flex gap-2">
          <div className="w75">
            <div className="addp-container">
              <p className="pt-1 mb-3">
                {" "}
                <b>Project People</b>
              </p>
              <hr style={{ margin: "0px", marginTop: "5px" }} />
              <div className="sec-height">
                <div className="d-flex gap-2"  >
                  <div className="w35 d-flex gap-1 p-0 mt-1">
                    <div className="w40">
                      <MultiSelect
                        onChange={userHandleChange}
                        options={option?.userOption}
                        filter
                        filterInputAutoFocus
                        name="user"
                        placeholder="Users"
                        value={projectData?.user}
                        optionLabel="name"
                        className="input-dd"
                        panelHeaderTemplate={(options) =>
                          PanelHeaderTemplate(
                            options,
                            "users",
                            projectData?.user,
                            () => { },
                            () =>
                              setProjectData((prevState) => ({
                                ...prevState,
                                user: [],
                              }))
                          )
                        }
                      />
                    </div>
                    <div className="w30">
                      <Dropdown
                        showClear
                        onChange={userHandleChange}
                        name="projectRole"
                        options={option?.projectRoleOption}
                        filter
                        filterInputAutoFocus
                        placeholder="Role"
                        value={projectData?.projectRole}
                        optionLabel="project_role_name"
                        className="input-dd"
                      />
                    </div>
                    <div className="w30">
                      <Dropdown
                        showClear
                        onChange={userHandleChange}
                        name="category_id"
                        options={option?.category}
                        filter
                        filterInputAutoFocus
                        placeholder="Category"
                        value={projectData?.category_id}
                        optionLabel="category_name"
                        optionValue="category_id"
                        className="input-dd"
                      />
                    </div>
                  </div>
                  <div className="w65 p-0 d-flex gap-1 justify-content-between align-items-center inspectra-calendar mt-1" >
                    <div className="ms-1" style={{width:"150px"}}>
                      <MultiSelect
                        onChange={userHandleChange}
                        options={option?.category}
                        filter
                        filterInputAutoFocus
                        name="communicators_category_ids"
                        placeholder="communicators"
                        value={projectData?.communicators_category_ids}
                        optionLabel="category_name"
                        optionValue="category_id"
                        className="input-dd w100"
                        panelHeaderTemplate={(options) =>
                          PanelHeaderTemplate(
                            options,
                            "communicators_category_ids",
                            projectData?.communicators_category_ids,
                            () => { },
                            () =>
                              setProjectData((prevState) => ({
                                ...prevState,
                                communicators_category_ids: [],
                              }))
                          )
                        }
                      />
                    </div>
                    <div>
                      <Calendar
                        className="input-dd"
                        dateFormat="dd-mm-yy"
                        style={{ border: "1px solid #e4e5e9", padding: "0px", height: "30px" }}
                        placeholder="Alloted Date"
                        name="user_start_date"
                        value={projectData?.user_start_date}
                        onChange={handleChange}
                        minDate={new Date(new Date().setDate(new Date().getDate() - 2))}
                      />
                    </div>
                    <div >
                      <Calendar
                        className="input-dd"
                        dateFormat="dd-mm-yy"
                        style={{ border: "1px solid #e4e5e9", padding: "0px", height: "30px" }}
                        placeholder="Expiry Date"
                        name="user_end_date"
                        value={projectData?.user_end_date}
                        onChange={handleChange}
                        minDate={new Date(projectData?.user_start_date)}
                        maxDate={
                          projectData?.projectRole?.exp_days > 0
                            ? new Date(new Date().setDate(
                              new Date().getDate() + projectData?.projectRole?.exp_days
                            ))
                            : new Date(new Date().setDate(
                              new Date().getDate() + 30
                            ))
                        }
                      />
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <label htmlFor="is_build_allow" title="Billable" className="ms-1 text-truncate  d-flex gap-1 align-items-center">
                        <input
                          type="checkbox"
                          id="checkbox"
                          name="is_billable"
                          className="m-0"
                          checked={projectData?.is_billable}
                          onChange={handleRadioChange}
                        />
                        Billable
                      </label>
                      {
                        !getValuePermission("allow_project_build_input") &&
                        <label htmlFor="is_build_allow" title="Allow Build" className="ms-1  text-truncate d-flex gap-1 align-items-center">
                          <input
                            type="checkbox"
                            id="checkbox"
                            name="is_build_allow"
                            className="m-0"
                            checked={projectData?.is_build_allow}
                            onChange={userHandleChange}
                          /> Allow Build</label>
                      }
                      {
                        !getValuePermission("allow_project_server_access_input") &&
                        <label htmlFor="is_server_build_allow" title="Server Access" className="ms-1 text-truncate d-flex gap-1 align-items-center">
                          <input
                            type="checkbox"
                            id="checkbox"
                            name="is_server_build_allow"
                            className="m-0"
                            checked={projectData?.is_server_build_allow}
                            onChange={userHandleChange}
                          />
                          Server Access</label>
                      }

                      {
                        !getValuePermission("auto_build_permission_input") &&
                        <label htmlFor="is_auto_build_request_permission" title="Auto Build Permission" className="ms-1 text-truncate d-flex gap-1 align-items-center">
                          <input
                            type="checkbox"
                            id="checkbox"
                            name="is_auto_build_request_permission"
                            className="m-0"
                            checked={projectData?.is_auto_build_request_permission}
                            onChange={userHandleChange}
                          />
                          Build Permission</label>
                      }
                    </div>
                    {
                      projectData?.is_project_lead && <div
                        className="mt-1 text-center w5">
                        <button
                          className="btn btn-primary"
                          onClick={addProjectUserRole}
                        >
                          +{" "}
                        </button>
                      </div>
                    }
                  </div>
                </div>
                {projectData?.project_user_roles?.length > 0 && (
                  <div className="data-table addp-table">
                    <table>
                      <tr className="sticky-header">
                        <th>Name</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>Role</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>Category</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>Communicators</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>Alloted Date</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>Expiry Date</th>
                        <th style={{ borderLeft: "1px solid #fff" }}>
                          Billable
                        </th>
                        {
                          !getValuePermission("allow_project_build_input") && <th style={{ borderLeft: "1px solid #fff" }} >
                            Build Allow
                          </th>
                        }
                        {
                          !getValuePermission("allow_project_server_access_input") && <th style={{ borderLeft: "1px solid #fff" }} >
                            Server Allow
                          </th>
                        }
                        {
                          !getValuePermission("auto_build_permission_input") && <th style={{ borderLeft: "1px solid #fff" }} >
                            Build Permission
                          </th>
                        }
                        <th style={{ borderLeft: "1px solid #fff" }}>Remove</th>
                      </tr>
                      {projectData?.project_user_roles?.map((val, index) => {
                        return (
                          !val?.is_remove && (
                            <tr key={index}>
                              <td>{val?.name || val?.user_display_name}</td>
                              <td>{val?.project_role_name}</td>
                              <td> <Dropdown
                                onChange={(e) => {
                                  addProjectUserRole("category_id", e.value, val)
                                }}
                                name="category_id"
                                options={option?.category}
                                filter
                                filterInputAutoFocus
                                placeholder="Category"
                                value={val?.category_id}
                                optionLabel="category_name"
                                optionValue="category_id"
                                className="input-dd"
                              /></td>
                              <td style={{width:"200px"}}>
                                <div className="d-flex w100 justify-content-center" style={{width:"200px"}}>
                                  <MultiSelect
                                    onChange={(e) => {
                                      val.communicators_category_ids = e.target.value || [];
                                      val.isChange = true
                                      setProjectData((prev) => ({ ...prev, project_user_roles: [...projectData?.project_user_roles] }))
                                    }}
                                    options={option?.category}
                                    filter
                                    filterInputAutoFocus
                                    name="communicators_category_ids"
                                    placeholder="communicators"
                                    value={val?.communicators_category_ids}
                                    optionLabel="category_name"
                                    optionValue="category_id"
                                    className=" w100"
                                    onHide={() => { if (val?.isChange) { addProjectUserRole("communicators_category_ids", val.communicators_category_ids, val) } }}
                                  />
                                </div>
                              </td>
                              <td>{dateConvert(val?.alloted_date)}</td>
                              <td className="inspectra-calendar w15">
                                <Calendar
                                  value={val?.expired_date ? new Date(val?.expired_date) : null}
                                  onChange={(e) => {
                                    addProjectUserRole("expired_date", e.target?.value, val)
                                  }}
                                  className="input-dd"
                                  dateFormat="dd-mm-yy"
                                  minDate={new Date()}
                                />
                              </td>
                              <td className="text-center">
                                <input
                                  type="checkbox"
                                  checked={
                                    val?.is_billable === undefined
                                      ? true
                                      : val?.is_billable
                                  }
                                  onChange={() => {
                                    handleRadioChange(val?.is_billable ? false : true, val, "list")

                                  }}
                                />
                              </td>
                              {
                                !getValuePermission("allow_project_build_input") &&
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    checked={
                                      val?.is_build_allow === undefined
                                        ? false : val?.is_build_allow
                                    }
                                    onChange={() => {
                                      addProjectUserRole("is_build_allow", val?.is_build_allow ? false : true, val)
                                    }}
                                  />
                                </td>
                              }
                              {
                                !getValuePermission("allow_project_server_access_input") &&
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    checked={
                                      val?.is_server_build_allow === undefined
                                        ? false : val?.is_server_build_allow
                                    }
                                    onChange={() => {
                                      addProjectUserRole("is_server_build_allow", val?.is_server_build_allow ? false : true, val)

                                    }}
                                  />
                                </td>
                              }
                              {
                                !getValuePermission("auto_build_permission_input") &&
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    checked={
                                      val?.is_auto_build_request_permission === undefined
                                        ? false : val?.is_auto_build_request_permission
                                    }
                                    onChange={() => {
                                      addProjectUserRole("is_auto_build_request_permission", val?.is_auto_build_request_permission ? false : true, val)

                                    }}
                                  />
                                </td>
                              }
                              <td
                                className="text-center"
                              >
                                {
                                  projectData?.is_project_lead && <FontAwesomeIcon
                                    icon="fa-solid fa-trash"
                                    className="remove"
                                    onClick={() => deleteUser(val)}
                                  />
                                }

                              </td>
                            </tr>
                          )
                        );
                      })}
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="w25">
            <div className="addp-container">
              <div className="d-flex justify-content-between">
                <p className="pt-1">
                  {" "}
                  <b>Issue Type Permission</b>
                </p>
                <button className="btn btn-primary-text" onClick={addRow}>
                  Add More
                </button>
              </div>
              <hr style={{ margin: "0px", marginTop: "5px" }} />
              <div className="addp-container-sub">
                <div>
                  {rows.map((row, index) => (
                    <div className="row gap-2" key={index}>
                      <div className="col-md-4 col-4 px-0">
                        <Dropdown
                          placeholder="Issue type"
                          options={option?.issueTypeOption}
                          optionLabel="issue_type_name"
                          className="input-dd"
                          onChange={(e) =>
                            handleDropdownChange(index, e.target.value)
                          }
                          value={row?.issueType}
                          filter
                          filterInputAutoFocus
                        />
                      </div>
                      <div className="col-md-6 col-6 px-0">
                        <MultiSelect
                          options={option?.projectUser?.map((user) => ({
                            name: user.user_display_name,
                            user_code: user.user_code,
                          }))}
                          filter
                          filterInputAutoFocus
                          placeholder="Users"
                          value={row?.user}
                          optionLabel="name"
                          onChange={(e) =>
                            handleMultiSelectChange(index, e.target.value)
                          }
                          panelHeaderTemplate={(options) =>
                            PanelHeaderTemplate(
                              options,
                              "users",
                              rows?.user,
                              () => { },
                              () => handleEvent(index)
                            )
                          }
                        />
                      </div>
                      <div className="col-md-1 col-2 px-0"
                        ref={() => checkPermission("Project Highlight", tagRef)}
                      >
                        {row?.issueType && row?.user?.length > 0 && (
                          <button
                            ref={tagRef}
                            id='{"tabname": "Project Highlight", "data": "add_project_issue_type_save_btn"}'
                            className="btn btn-danger-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              deleteIssueType(row?.issueType, index);
                            }}
                          >
                            <FontAwesomeIcon icon="fa-solid fa-trash" />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-end mt-2">
                <button
                  ref={tagRef}
                  id='{"tabname": "Project Highlight", "data": "add_project_issue_type_save_btn"}'
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    addIssueType();
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog visible={showPopup} onHide={() => { setShowPopup(false); setConfirmation({}); handleSelection(confirmation?.list); }} draggable={false} className='modal-xsmall' >
        {
          confirmation?.list ? <p>
            {`These users (${mismatchedUsers.map(u => u.user_display_name).join(", ")}) is  ${confirmation?.is_billable ? " Billable" : "Non-Billable"}. Would you like to update them?`}
          </p> : <p>
            {`These users (${mismatchedUsers.map(u => u.name).join(", ")}) are  ${projectData?.is_billable ? " Non-Billable" : "Billable"}. Would you like to update them?`}
          </p>
        }
        {
          confirmation?.is_update && <input
            type="text"
            value={confirmation?.remark}
            placeholder="Enter remark"
            className='input-text m-0 w100'
            onChange={(e) => { setConfirmation((prev) => ({ ...prev, remark: e.target.value })) }}
          />
        }
        <div className="d-flex gap-2 justify-content-center align-items-center py-2 ">
          {
            confirmation?.is_update ?
              <button className='btn-primary' onClick={() => {
                if (!confirmation?.remark?.trim()) {
                  showInfo("info", "Please enter remark.");
                  return;
                }
                confirmation?.list && addProjectUserRole("is_billable", confirmation?.newvalue, confirmation?.user);
                setShowPopup(false)
              }}>Submit</button> :
              <>
                <button className='btn-primary' onClick={() => { setConfirmation((prev) => ({ ...prev, is_update: true })) }}>Yes</button>
                <button className='btn-default' onClick={() => {
                  handleSelection(confirmation?.list);
                  setShowPopup(false);
                  setConfirmation({ is_update: false, remark: '', list: null });
                }}>No</button></>
          }
        </div>
      </Dialog>
    </>
  );
};

export default AddOrEditProject;
